import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { colors } from 'theme/colors';

const StyledStepTitle = styled(Typography)`
  font-weight: bold;
  padding-bottom: 24px;
  border-bottom: 1px solid ${colors.black};
  margin-bottom: 24px;
`;

const StyledSectionTitle = styled(Typography)`
  font-weight: bold;
  margin-bottom: 40px;
  margin-top: 40px;
`;

const StyledParagraph = styled(Typography)`
  margin-bottom: 16px;
`;

const StyledList = styled.ul`
  font-family: NotoSansRegular, sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;

  & li {
    list-style-type: disc;
    margin-left: 20px;
  }
`;

export { StyledStepTitle, StyledSectionTitle, StyledParagraph, StyledList };
